import { Component, OnInit, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { RouterLink } from '@angular/router';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { RouterModule } from '@angular/router';
import { HeaderComponent } from '../../components/header/header.component';
import { FooterComponent } from '../../components/footer/footer.component';
import { ActivatedRoute, Router } from '@angular/router';
import { RegTokenServiceService } from '@services/reg-token-service.service';
import { Globals } from 'src/app/globals';
import { AuthServiceService } from '@services/auth-service.service';
import { LoaderService } from '@services/loader.service';
import { RegUser } from '../basic-reg/RegUser';

@Component({
  selector: 'app-payment-confirmation',
  standalone: true,
  templateUrl: './payment-confirmation.component.html',
  styleUrls: ['./payment-confirmation.component.scss'],
  imports: [
    CommonModule,
    IonicModule,
    RouterModule,
    RouterLink,
    HeaderComponent,
    FooterComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA]
})
export class PaymentConfirmationComponent implements OnInit {
  user: RegUser = {} as RegUser;
  paymentSuccessful: boolean = false;
  encounterNo: string = '';
  adjFlagTime: string = '';
  deviceId: string = '';
  deviceIdList: any[] = [];
  transactionId: string = '';
  transactionNo: string = '';
  requestPath = '';
  message: string = '';

  constructor(
    private route: ActivatedRoute,
    private global: Globals,
    private router: Router,
    private regTokenService: RegTokenServiceService,
    private authService: AuthServiceService,
    private loader: LoaderService) {

    this.requestPath = this.global ? this.global.requestPath : '';

    this.route.params.subscribe(params => {
      // Accept both boolean and string for paymentSuccessful
      const successParam = params['success'];
      this.paymentSuccessful = (successParam === true || successParam === 'true');
      this.transactionNo = params['transactionNo'];

      if (this.global.isEmpty(this.transactionNo) || this.global.isEmpty(successParam)) {
        this.router.navigate(['/home']);
      }

      if (this.paymentSuccessful) {
        this.encounterNo = this.regTokenService.getEncounterNo();
        this.adjFlagTime = this.regTokenService.getAdjustedFlagTime();
        this.deviceId = this.regTokenService.getDeviceId();
        this.deviceIdList = this.regTokenService.getDeviceIdList().split(",");
        this.transactionId = this.regTokenService.getTransactionId();

        if (this.global.isEmpty(this.encounterNo) || this.global.isEmpty(this.adjFlagTime)
          || this.global.isEmpty(this.deviceId) || this.global.isEmpty(this.deviceIdList)
          || this.global.isEmpty(this.transactionId) || this.global.isEmpty(this.transactionNo)) {
          this.router.navigate(['/home']);
        }

        this.markPayDone();
      }
    });
  }

  ngOnInit(): void {}

  ionViewDidEnter() {
    this.user = this.authService.getLoggedInUser();
  }

  markPayDone = () => {
    var regMessage = this.regTokenService.getDefaultMessage();
    // Device ID is actual device id, and sender id is phone/laptop id
      // Extend the message object to allow custom properties
      const regMessage2 = this.regTokenService.getDefaultMessage() as any;
      regMessage2.senderId = this.deviceId;
      regMessage2.encounterNo = this.encounterNo;
      regMessage2.adjustedFlagTime = this.adjFlagTime;
      (regMessage2 as any).transactionNo = this.transactionNo;
      (regMessage2 as any).transactionId = this.transactionId;
      (regMessage2 as any).deviceIdList = this.deviceIdList;

    this.loader.show("Processing...");
    this.authService.postDefaultEncryptCore('enrollment/?' + this.requestPath + '=transactionSecurityLimitCheckup', regMessage2)
      .subscribe((res: any) => {
        this.loader.hide();
        if (res.success) {
          // Payment is successful
        } else {
          this.message = res.message;
        }
      }, (error: any) => {
        this.loader.hide();
        this.message = 'Error occured, please try again.';
      });
  }
}
